import { IProfile } from "../services";
import { ItaEnvironment } from "../store/Profile/enum/Ita-environment";
import { ItaNonProdPolicy } from "../store/Profile/enum/Ita-nonprod-policy";
import { ItaProdPolicy } from "../store/Profile/enum/Ita-prod-policy";

type Maybe<X> = X | undefined | null;
type MaybeProfile = Maybe<IProfile>;
type MaybeDate = Maybe<Date>;

export const CheckForCreateBids = (profilePage : IProfile) => {
    let disabled = false;
    if (profilePage?.environment === ItaEnvironment.PRD) {
        if (profilePage?.itaProdPolicy === ItaProdPolicy.Read) {
            disabled = true;
        }
    }
    else {
        if (profilePage?.itaNonProdPolicy === ItaNonProdPolicy.ReadNonProd) {
            disabled = true;
        }
    }
    return disabled;
}

export const CheckForBidPanelFunctionalities = (profilePage : MaybeProfile) => {
    let disabled = false;
    if (profilePage?.environment === ItaEnvironment.PRD) {
        if (profilePage?.itaProdPolicy === ItaProdPolicy.Read) {
            disabled = true;
        }
    }
    else {
        if (profilePage?.itaNonProdPolicy === ItaNonProdPolicy.ReadNonProd) {
            disabled = true;
        }
    }
    return disabled;
}

export const CheckForEtrmConfiguration = (profilePage : MaybeProfile) => {
    let disabled = false;
    if (profilePage?.environment === ItaEnvironment.PRD) {
        if (profilePage?.itaProdPolicy === ItaProdPolicy.Read) {
            disabled = true;
        }
    }
    else {
        if (profilePage?.itaNonProdPolicy === ItaNonProdPolicy.ReadNonProd) {
            disabled = true;
        }
    }
    return disabled;
}

export const CheckForExchangeConfiguration = (profilePage : MaybeProfile) => {
    let disabled = false;
    if (profilePage?.environment === ItaEnvironment.PRD) {
        if (profilePage?.itaProdPolicy === ItaProdPolicy.Read
            || profilePage?.itaProdPolicy === ItaProdPolicy.Write) {
            disabled = true;
        }
    }
    else {
        if (profilePage?.itaNonProdPolicy === ItaNonProdPolicy.ReadNonProd
            || profilePage?.itaNonProdPolicy === ItaNonProdPolicy.WriteNonProd) {
            disabled = true;
        }
    }
    return disabled;
}

export const canSubmitReturn = (profilePage : MaybeProfile) => 
    profilePage?.environment === ItaEnvironment.PRD
        ? profilePage?.itaProdPolicy !== ItaProdPolicy.Read
        : profilePage?.itaNonProdPolicy !== ItaNonProdPolicy.ReadNonProd

/**
 * Checks if the resale deadline for an auction has passed
 * @param resaleDeadline The resale deadline date of the auction
 * @returns boolean indicating if the resale deadline has passed
 */
export const isReturnWindowOpen = (capacityReturnGateOpen: MaybeDate, capacityReturnGateClose: MaybeDate): boolean => {    
  if (!capacityReturnGateOpen) {
    return false; // If no gate open is provided, disable the button
  }

  if (!capacityReturnGateClose) {
    return false; // If no gate close is provided, disable the button
  }

    // Check if the current date is within the return gate open and close times
  const currentDate = new Date();
  return currentDate >= new Date(capacityReturnGateOpen) &&
         currentDate <= new Date(capacityReturnGateClose);
};